import { transIntTo2Str } from "./dataUtils";
import { meshLog } from "./spUtils";
//获取time小时
export const getTimeHour = () => {
    let arr = [];
    arr[0] = { value: 0,'label': 12+"h"}  
    for (let i = 1; i <= 12; i++) {
        arr[i] = { value: i,'label': i+"h"}  
    }
    for (let i = 1; i <= 11; i++) {
        arr[12+i] = { value: 12+i,'label': i+"h"}  
    }
    return arr;
}

//获取time小时
export const getTimeMin = () => {
    let arr = [];
    for (let i = 0; i < 60; i++) {
        arr[i] = { value: i,'label': transIntTo2Str(i)+"min"}  
    }
    return arr;
}

//yyyyMMddHHmmss
export const exportTimeStr = () => {
  let time = new Date();
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let day = time.getDate();
  let hour = time.getHours();
  let min = time.getMinutes();
  let sec = time.getSeconds();
  let str = year + transIntTo2Str(month) + transIntTo2Str(day) + transIntTo2Str(hour) + transIntTo2Str(min) + transIntTo2Str(sec);
//   meshLog("wjk time:" + str);
  return str;
}


//yyyy-MM-dd HH:mm:ss
export const exportTimeFormatter = () => {
  let time = new Date();
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let day = time.getDate();
  let hour = time.getHours();
  let min = time.getMinutes();
  let sec = time.getSeconds();
  let str = year +"-"+ transIntTo2Str(month)+"-" + transIntTo2Str(day)+" " + transIntTo2Str(hour) +":"+ transIntTo2Str(min)+":" + transIntTo2Str(sec);
//   meshLog("wjk time:" + str);
  return str;
}

export const exportTimeSpecial = (str) => {
    let time = new Date(str);
    let year = time.getFullYear();
    let month = time.getMonth() + 1;
    let day = time.getDate();
    let mm="Jan";
    if(month==1){
      mm="Jan";
    }else if(month==2){
      mm="Feb";
    }else if(month==3){
      mm="Mar";
    }else if(month==4){
      mm="‌Apr";
    }else if(month==5){
      mm="May";
    }else if(month==6){
      mm="‌Jun";
    }else if(month==7){
      mm="Jul";
    }else if(month==8){
      mm="Aug";
    }else if(month==9){
      mm="Sep";
    }else if(month==10){
      mm="Oct";
    }else if(month==11){
      mm="‌Nov";
    }else if(month==12){
      mm="Dec";
    }
    return mm +" "+day+", "+year;
}

export const exportTimeInterval = () => {
    let time = (new Date().getTime())/1000;
    time=parseInt(time)
    // meshLog("wjk time:" + time);
    return time;
}




